"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var axios_1 = __importDefault(require("axios"));
var auth_1 = require("../auth");
var create = function (baseURL, config) {
    var _a;
    if (config === void 0) { config = null; }
    var http = axios_1.default.create(__assign({ withCredentials: (_a = config === null || config === void 0 ? void 0 : config.withCredentials) !== null && _a !== void 0 ? _a : false, baseURL: baseURL }, config));
    http.interceptors.response.use(function (response) { return response; }, errorHandler);
    http.interceptors.request.use(function (request) {
        return request;
    });
    return http;
};
exports.create = create;
var errorHandler = function (error) {
    var _a, _b, _c, _d;
    var errorMessage = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error_description) !== null && _c !== void 0 ? _c : 'generic';
    // Logout user on 401
    if (((_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.status) === 401) {
        auth_1.auth.instance.onLogoutHook({
            msg: errorMessage,
        });
    }
    return Promise.reject(new Error(errorMessage));
};
